import React from 'react';
import './index.scss';

/*istanbul ignore next */
export default function Loader({ full = false }) {
  const loader = (
    <div className="loader" data-html2canvas-ignore data-testid={'loader'}>
      <div />
      <div />
      <div />
    </div>
  );

  return full ? <div className={'full-width-loader'}>{loader}</div> : loader;
}
